// extracted by mini-css-extract-plugin
export default {"close":"actionModal_close__QLuc2","title":"actionModal_title__j+p3R","centeredTitle":"actionModal_centeredTitle__TEObe","titleBlock":"actionModal_titleBlock__OnQge"};